import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [me, setMe] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setMe(data);
      return data;
    } catch {
      setMe(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      if (window.caches) {
        const keys = await caches.keys();
        await Promise.all(keys.filter((k) => k.startsWith("mr-data")).map((k) => caches.delete(k)));
      }
      setMe(false);
    }
  };

  return <AuthCtx.Provider value={{ me, setMe, refresh, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const can = (me, perm) => Boolean(me && me.permissions?.includes(perm));

export function homeFor(me) {
  if (!me) return "/app/connexion";
  if (me.is_staff) return "/console";
  if (me.user.status === "candidat") return "/candidature";
  return "/app";
}
